<template>
  <div class="field-option-date-picker-wrapper">
    <van-field
      :value="value"
      readonly
      label="时间段"
      size="large"
      placeholder="请选择时间段"
      right-icon="arrow"
      @click="togglePicker"
    />
    <span class="keep border-bottom" />

    <van-popup v-model="isPickerShown" position="bottom">
      <van-picker
        title="选择时间段"
        show-toolbar
        :columns="columns"
        @cancel="togglePicker"
        @confirm="handleConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      value: '',
      isPickerShown: false,
    };
  },
  computed: {
    columns() {
      const arr = this.items.map(({ start_time: start, end_time: end, count }) => {
        return `${start} ~ ${end} 库存:${count === -1 ? '不限' : count}`;
      });
      return arr;
    },
  },
  watch: {
    columns(newVal) {
      if (newVal.length && !this.value) {
        this.handleConfirm(undefined, 0);
        this.togglePicker();
      }
    },
  },
  methods: {
    togglePicker() {
      this.isPickerShown = !this.isPickerShown;
    },
    handleConfirm(_, index) {
      const { start_time: start, end_time: end } = this.items[index];
      this.value = `${start} ~ ${end}`;
      this.$emit('change', this.items[index]);
      this.togglePicker();
    },
  },
};
</script>
